module.exports = __webpack_public_path__ + "static/turtle-creek-house49-eade1a17bfb0c3cf63921a1dbd9a6102.jpg";